'use client'
import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import type { FC } from 'react'
import styled, { css } from 'styled-components'
import { useDeviceType, useModal } from '@/hooks'
import { MODALS } from '@/context'
import { Modal } from './Modal'
import { Img, SliderFlickity } from '../commons'
import { mq, rgbAlpha, vw } from '@/styles'

const getSlides = (media) => media.map((img, idx) => {
  if (!img) return null

  return (
    <div key={idx} className='img-wrapper'>
      <Img media={img.image} />
    </div>
  )
})


export const ModalZoom:FC = memo(({ }) => {
  const { isActive, payload, updatePayload } = useModal(MODALS.ZOOM)
  const [sliderData, setSliderData] = useState(payload?.media ?? null)

  const { isMobile } = useDeviceType()
  const Slides = useMemo(() =>  sliderData?.length > 0 && getSlides(sliderData), [sliderData])

  useEffect(() => {
    if (payload?.media && isActive) {
			queueMicrotask(() => setSliderData(payload.media))
		}
  }, [isActive, payload?.media])

  const onClose = useCallback(() => {
    updatePayload({ payload: { media: null }, open: false, close: true })
  }, [updatePayload])

  return (
    <Modal isActive={isActive} close={onClose} title={''} xAlign={isMobile? 'right' : 'center'} size={'auto'} zIndex={1002} hasHeader={true} dialogStyles={dialogStyles}  hasToClose={true}>
      <Div className='product_slider'>
        {Slides?.length > 0 &&  <SliderFlickity options={{ cellAlign: 'left', autoPlay: true, prevNextButtons: sliderData?.length > 1, imagesLoaded: true, draggable: sliderData?.length > 1 }} className='fade'>
          {Slides}
        </SliderFlickity>
        }
      </Div>
    </Modal>
  )
})



const dialogStyles= css`
  background-color: var(--color-background);
  display: flex;
  flex-direction: column;
  height: 100vh !important;
  height: 100dvh !important;
  margin: 0;
  overflow: hidden;
  top: 0;

  ${mq.greaterThan('nexus7')} {
    height: 100vh;
    height: 100dvh;
    top: 0;
  }

  ${mq.greaterThan('tablet')} {
    height: 95vh;
    top: 0;
  }

  ${mq.greaterThan('desktop')} {
    height: 95vh;
    top: 0;
  }

  .modal__body {
    height: 100%;
    overflow: auto;
    padding: 0;

    .slider {
      display: flex !important;
      flex-direction: row !important;
    }
  }

  header {
    flex-shrink: 0;
    height: 40px;

    button {
      transform: translateY(5px);
    }
  }
`

const Div = styled.div`
  display: grid;
  grid-column: 1 / span 6;
  grid-row-gap: ${vw(20, 'mobile')};
  grid-row: 3 / span 1;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  margin-top: 0;
  overflow: hidden;
  padding-top: 20px;
  position: relative;
  margin-bottom: 0;

  ${mq.greaterThan('tablet')}{
    grid-column: 1/span 8;
    grid-row-gap: 0;
    grid-template-columns: repeat(5, 1fr);
    margin-top: 0;
  }

  .slider-wrapper {
    height: calc(100% - 20px);
    left: 0;
    position: absolute;
    top: 20px;
    width: 100%;
  }


  .flickity-slider {
    margin: 0 auto !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .flickity-button {
    align-items: center;
    background: ${rgbAlpha('--color-creme', 0.5)};
    border-radius: 50%;
    bottom: 45%;
    display: flex;
    height: 30px;
    justify-content: center;
    position: absolute;
    user-select: none;
    width: 30px;

    svg {
      height:15px;
      width:15px;
    }

    &.previous {
      left: 10px;
      right: auto;
    }

    &.next {
      left: auto;
      right: 10px;
    }

    &:disabled {
      display: none;
      opacity: .25;
      pointer-events: none;
    }

    .flickity-button-icon {
      fill: var(--color-white);
    }
  }

  .flickity-slider {
    padding: 0 8px;
    width: 100% !important;

    .img-wrapper {
      height: calc(90vh - 50px);
    }

    img {
      height: calc(90vh - 50px);
      max-height: 100%;
      max-width: 100%;
      object-fit: contain;
    }
  }
`
